import type { IAdminSecAdvFirmDetail } from '../../api/sec-adv-contracts';
import { formatDay } from '../../components/days';
import { ParticipantsCard, PreviewCard } from '../sec-adv-firm-page';
import { Figure } from './panel';

/** A firm's Internal tab (SR-423): what the product holds about it rather than what it filed — the
 *  participants holding its numbers, what a survey response opened now would be prefilled with,
 *  and the daily feed its row came from. */
export function FirmInternal({ firm }: { firm: IAdminSecAdvFirmDetail }) {
  return (
    <div className="grid gap-4">
      <div className="rounded-lg border border-border bg-card p-4 text-sm">
        <Figure label="Feed date">{formatDay(firm.feedDate)}</Figure>
      </div>
      <ParticipantsCard participants={firm.participants} />
      <PreviewCard prefill={firm.prefill} />
    </div>
  );
}
